export const getJson = async (url, accessToken) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    },
  };
  const response = await fetch(url, requestOptions);
  return await response.json();
};
